<template>
  <div class="transactions-day">
    <div class="transactions-day-title">
      {{ getTransactionDayTitle() }}
    </div>
    <div class="transactions-day-list">
      <Transaction v-for="(transaction, index) in transactions" :transaction="transaction" :index="index"/>
    </div>
  </div>
</template>

<script setup>
  import Transaction from "@/components/Transaction/Transaction.vue";

  const props = defineProps({
    'date': {
      type: String,
    },
    'transactions': {
      type: Array,
    }
  })

  const getTransactionDayTitle = () => {
    const dateString = props.transactions[0].date;

    const today = new Date();

    if (getDateString(today) === dateString) {
      return "Aujourd'hui";
    }

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (getDateString(yesterday) === dateString) {
      return "Hier";
    }

    return dateString;
  }

  let getDateString = (date) => {
    const day = String(date.getDate()).padStart(2, '0');  // Day of the month (2 digits)
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Month (2 digits)
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };
</script>

<style scoped lang="scss">
  .transactions-day {
    margin-bottom: 20px;

    .transactions-day-title {
      text-align: left;
      color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }

    .transactions-day-list {
      display: flex;
      padding: 8px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-self: stretch;

      border-radius: 20px;
      border: 1px solid var(--ce-color-blue-ce-marque-blanche-50, rgba(39, 92, 241, 0.04));
      background: var(--ce-color-light-100, #FFF);
    }
  }
</style>
